import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-thank-you-page',
  templateUrl: './thank-you-page.component.html',
  styleUrls: ['./thank-you-page.component.css']
})
export class ThankYouPageComponent implements OnInit, OnDestroy {
  
  language!: string;
  routeSub!: Subscription;
  
  constructor(
    private route: ActivatedRoute    
  ) { }
  
  
  ngOnInit(): void {
    this.language = this.route.snapshot.url[0].path;    
  }

    ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }
}
